// HORO-10649: build an absolute URL for a file in `public/`. Root-absolute
// paths like `/image/...` resolve against whichever host the visitor is on,
// so under /veda on astrology.com they hit the main site — some 404, others
// return an unrelated image with a 200.
//
// NOT `getAppBasename()`: nginx serves index.html for everything under /veda,
// so a basename-prefixed image URL returns HTML with a 200 and still fails.
// PUBLIC_URL is the app's own origin (from REACT_APP_BASE_URL) and is the
// same value CRA stamps onto the bundle, so it is correct in every
// environment. Empty in tests, where a root-relative path is fine.
//
// Deliberately its own module rather than part of `helper.js`: that file
// imports the Redux store, which would drag the whole store into every
// consumer — and into jest, where redux-persist's ESM build fails to parse.
export const publicAsset = (path) => `${process.env.PUBLIC_URL || ''}${path}`;
